import React from "react";
import * as mobx from "mobx";
import { observable, action } from "mobx";
import { Form, Field } from "mobx-react-form";
import { WeaTools } from "ecCom";
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import isArray from "lodash/isArray";
import cloneDeep from "lodash/cloneDeep";
import isFunction from "lodash/isFunction";
import isObject from "lodash/isObject";
import each from "lodash/each";
import validatorjs from "./validatorjs";
import getRules from "./rules";
import asyncRules from "./asyncRules";
import { Base64 } from "js-base64";

import { WeaFormItem, WeaSearchGroup, WeaLocaleProvider } from "ecCom";
import WeaSwitch from "../wea-switch";

const getKey = WeaTools.getKey;
const types = WeaTools.types;
const toJS = mobx.toJS;

class MyField extends Field {
  @observable valueSpan = null;
  @observable valueObj = null;

  onChange = (...args) => {
    args = mobx.toJS(args);
    if (args[1]) this.valueSpan = args[1];
    if (args[2]) this.valueObj = args[2];
    this.set(args[0] || "");
    if (typeof args[0] === "number" || typeof args[0] === "boolean") {
      this.set(args[0]);
    }
    // onChange 关闭校验
    // this.validate();
    window.e9ChangedFormFieldKey = this.key;
    this.showErrors(false);
    return this.type === "file"
      ? this.onDrop(...args)
      : this.execHandler("onChange", args, this.sync);
  };

  reset(...args) {
    super.reset(...args);
    this.valueSpan = undefined;
    this.valueObj = undefined;
  }
}

const bindings = {
  default: {
    id: "id",
    name: "name",
    value: "value",
    valueSpan: "valueSpan",
    valueObj: "valueObj",
    label: "label",
    checked: "checked",
    placeholder: "placeholder",
    disabled: "disabled",
    onChange: "onChange",
    onBlur: "onBlur",
    onFocus: "onFocus",
    autoFocus: "autoFocus"
  }
};

let formPromise = null;
let formInitOrder = 0;

class WeaForm extends Form {
  fieldArr = [];
  fieldMap = {};
  @observable isFormInit = false;
  @observable condition = [];

  static MyField = MyField;

  constructor(props) {
    super(props);
    this.keyTypeMap = {};
    this.isFormInit = false;
    this.condition = [];
    window.e9ChangedFormFieldKey = "";
    window.e9HideFormFieldKeys = [];
  }

  makeField(props) {
    return new MyField(props);
  }

  bindings() {
    return bindings;
  }
  plugins() {
    return {
      dvr: {
        package: validatorjs,
        extend: $validator => {
          if (formInitOrder === 0) {
            formPromise = WeaLocaleProvider.getLocaleLabelByCode(
              "common",
              true
            );
          }
          formInitOrder = formInitOrder + 1;
          formPromise = formPromise.then(() => {
            $validator.useLang("zh");
            let messages = $validator.getMessages("zh");
            // $validator.setMessages('zh', messages);
            const rules = getRules();

            Object.keys(rules).forEach(key =>
              $validator.registerImplicit(
                key,
                rules[key].fn.bind(this),
                rules[key].message
              )
            );
            Object.keys(asyncRules).forEach(key =>
              $validator.registerAsyncRule(key, asyncRules[key])
            );
          });
        }
      }
    };
  }

  @action
  updateIsFormInit(v = false) {
    this.isFormInit = v;
    window.e9ChangedFormFieldKey = "";
  }

  formatField(fields, values, f) {
    f = toJS(f);
    const field = {};
    let key = getKey(f);
    let v = WeaTools.getValueByfield(f);
    // v = {value: "base"}
    if (v && v.value) {
      if (typeof v.value == "string" && v.value.indexOf("base64_") > -1) {
        v.value = Base64.decode(v.value.replace("base64_", ""));
      }
      values[key] = v;
    }
    // set default 0 and false
    if (v && (v.value === 0 || v.value === false)) {
      values[key] = v;
    }
    // 初始化fields
    field.label = `"${f.label}" `;
    if (f.rules) field.rules = f.rules;
    fields[key] = field;
    this.fieldMap[key] = f;
    this.keyTypeMap[key] = f.conditionType.toUpperCase();
    this.fieldArr.push(f);
  }

  @action
  initFormFields(condition, callback) {
    let fields = {};
    let values = {};
    condition &&
      condition.length > 0 &&
      condition.map(c => {
        c.items &&
          c.items.length > 0 &&
          c.items.map(f => {
            !isEmpty(f) && this.formatField(fields, values, f);
          });
      });
    this.initFields({ fields });
    this.isFormInit = true;
    this.updateFields(values); //根据默认条件初始化值
    isFunction(callback) && callback();
    window.e9ChangedFormFieldKey = "initFormNoNeedWarning";
  }

  @action
  initFormFieldObj(obj, callback) {
    let fields = {};
    let values = {};
    if (isArray(obj)) {
      obj.map(item => {
        !isEmpty(item) && this.formatField(fields, values, item);
      });
    } else {
      for (let i in obj) {
        let item = obj[i];
        !isEmpty(item) && this.formatField(fields, values, item);
      }
    }
    this.initFields({ fields });
    this.isFormInit = true;
    this.updateFields(values); //根据默认条件初始化值
    isFunction(callback) && callback();
    window.e9ChangedFormFieldKey = "initFormNoNeedWarning";
  }

  @action
  resetConditionValue() {
    // 保留select的默认值
    this.reset();
    let values = {};
    this.isFormInit &&
      this.fieldArr.map(item => {
        const type = item.conditionType.toUpperCase();
        if (
          types.SELECT === type ||
          types.DATE === type ||
          types.SELECT_LINKAGE === type
        ) {
          let key = getKey(item);
          let v = WeaTools.getValueByfield(item);
          if (v) values[key] = v;
        }
      });
    this.updateFields(values);
  }

  @action
  updateFields(datas, updateAll = false, needValidate = false) {
    if (this.isFormInit) {
      if (updateAll) this.resetConditionValue();
      const fields = this.fields;
      each(datas, (data, k) => {
        let item = fields.get(k);
        if (item) {
          if (isString(data)) {
            item.value = data;
          } else {
            item.value = data.value;
            item.valueSpan = data.valueSpan;
            item.valueObj = data.valueObj;
            if (types.BROWSER == this.keyTypeMap[k]) {
              if (isEmpty(data.valueObj) && data.value && data.valueSpan) {
                let replaceDatas = [];
                const v = data.value.split(",");
                const vs = data.valueSpan.split(",");
                v.forEach((item, index) => {
                  replaceDatas.push({
                    id: item,
                    name: vs[index]
                  });
                });
                item.valueObj = replaceDatas;
              }
            }
          }
        } else {
          console && console.warn(`${k} 未初始化  -- WeaForm`);
        }
      });
      if (needValidate) {
        this.validate();
      }
    }
  }

  getFormDatas() {
    let params = {};
    if (this.isFormInit) {
      this.each(f => {
        let key = f.key;
        let value = mobx.toJS(f.value);
        let valueSpan = f.valueSpan;
        let valueObj = f.valueObj;
        if (value !== undefined) {
          if (isArray(value) && value[1]) value[1] = mobx.toJS(value[1]); // 联动组件中的浏览按钮数据特殊处理
          params[key] = {
            value: value
          };
          if (valueSpan) params[key].valueSpan = valueSpan;
          if (valueObj) params[key].valueObj = mobx.toJS(valueObj);
        }
      });
    }
    return params;
  }

  getFormParams() {
    let params = {};
    if (this.isFormInit) {
      this.each(f => {
        if (isString(f.key) && f.key) {
          const field = cloneDeep(mobx.toJS(this.fieldMap[f.key]));
          let key;
          if (field && field.domkey) {
            key = field.domkey;
          } else {
            key = f.key.split("__");
          }
          let value = toJS(f.value);
          //hardcode 处理SELECT_LINKAGE类型的组件
          if (types.SELECT_LINKAGE == this.keyTypeMap[f.key]) {
            params[key[0]] = value[0];
            let target = mobx.toJS(value[1]);
            let targetKey = [];
            if (
              field &&
              field.selectLinkageDatas &&
              field.selectLinkageDatas[value[0]]
            ) {
              targetKey = field.selectLinkageDatas[value[0]].domkey;
              if (!isEmpty(targetKey)) {
                if (isString(target) && targetKey[0])
                  params[targetKey[0]] = target;
                if (isArray(target)) {
                  targetKey.forEach((k, i) => {
                    let item = target[i];
                    if (isArray(item)) item = item[0];
                    if (item !== undefined) params[k] = item;
                  });
                }
              }
            }
          } else {
            if (isObject(value) ? !isEmpty(value) : value != undefined) {
              if (key.length > 1) {
                key.forEach((k, i) => {
                  let item = mobx.toJS(value[i]);
                  if (isArray(item)) item = item[0];
                  if (item !== undefined) params[k] = item;
                });
              } else {
                params[key[0]] = value;
              }
            }
          }
        }
      });
    }
    return params;
  }

  getError(field) {
    let msg = "";
    if (this.isFormInit) {
      const key = getKey(field);
      const target = this.$(key);
      if (target) msg = target.errors();
      if (
        window.e9ChangedFormFieldKey &&
        key !== window.e9ChangedFormFieldKey
      ) {
        msg = "";
      }
      if (
        isArray(window.e9HideFormFieldKeys) &&
        !isEmpty(window.e9HideFormFieldKeys) &&
        window.e9HideFormFieldKeys.indexOf(key) > -1
      ) {
        msg = "";
      }
    }
    return msg;
  }

  showError(field, message) {
    let key = "";
    if (isString(field)) {
      key = field;
    } else if (isArray(field)) {
      key = field.join("__");
    } else {
      key = getKey(field);
    }
    const target = this.$(key);
    if (target) {
      window.e9ChangedFormFieldKey = key;
      target.invalidate(message);
      setTimeout(() => {
        target.invalidate("");
        window.e9ChangedFormFieldKey = "";
      }, 2000);
    }
  }

  validateForm() {
    window.e9ChangedFormFieldKey = "";
    this.each(f => {
      if (isString(f.key) && f.key) {
        const field = cloneDeep(mobx.toJS(this.fieldMap[f.key]));
        if (field && field.rules) {
          if (
            !isEmpty(window.e9HideFormFieldKeys) &&
            window.e9HideFormFieldKeys.indexOf(f.key) > -1
          ) {
            f.set("rules", "");
          } else {
            f.set("rules", field.rules);
          }
        }
      }
    });
    return this.validate();
  }

  resetForm() {
    window.e9ChangedFormFieldKey = "resetFormNoNeedWarning";
    window.e9HideFormFieldKeys = [];
    this.reset();
  }

  isHide(field = {}, cb) {
    return cb(field.domkey, this.getFormParams());
  }

  getField(key) {
    return this.fieldMap[key];
  }

  setEmpty(key) {
    let data = {};
    data[key] = {
      value: "",
      valueSpan: null,
      valueObj: null
    };
    this.updateFields(data);
  }

  setField(key, params) {
    if (isString(key) && toJS(this.condition) && !isEmpty(params)) {
      this.condition = toJS(this.condition).map(c => {
        if (c.items) {
          c.items.forEach(item => {
            if (key === getKey(item)) {
              for (let i in params) {
                item[i] = params[i];
              }
            }
          });
        } else {
          if (key === getKey(c)) {
            for (let i in params) {
              c[i] = params[i];
            }
          }
        }
        return c;
      });
    }
    if (this.fieldMap[key]) {
      this.setEmpty(key);
    }
  }

  setCondition(condition = [], deep = true) {
    this.condition = condition;
    if (deep) {
      this.initFormFields(toJS(condition));
    } else {
      this.initFormFieldObj(toJS(condition));
    }
  }

  getItem(field, comProps) {
    return {
      com: (
        <WeaFormItem
          ratio1to2
          label={`${field.label}`}
          error={this.getError(field)}
          fieldType={field.conditionType.toUpperCase()}
          viewAttr={field.viewAttr}
          tipPosition="bottom"
        >
          <WeaSwitch {...comProps} fieldConfig={field} form={this} />
        </WeaFormItem>
      ),
      hide:
        field.hide ||
        (field.otherParams &&
          (field.otherParams.type == "hidden" ||
            field.otherParams.hide == true)) ||
        (comProps.isHide &&
          comProps.isHide(getKey(field), this.getFormParams()))
    };
  }

  render(searchGroupProps = {}, comProps = {}, deep = true, customRender) {
    let group = [];
    if (this.isFormInit) {
      if (deep) {
        toJS(this.condition).map((c, idx) => {
          if (
            customRender &&
            isFunction(customRender) &&
            customRender(c, idx)
          ) {
            group.push(customRender(c, idx));
          } else {
            let items = [];
            c.items.map(field => {
              items.push(this.getItem(field, comProps));
            });
            group.push(
              <WeaSearchGroup
                needTigger={true}
                showGroup={c.defaultshow}
                {...searchGroupProps}
                title={c.title}
                items={items}
              />
            );
          }
        });
      } else {
        let items = [];
        toJS(this.condition).map(c => {
          items.push(this.getItem(c, comProps));
        });
        group.push(
          <WeaSearchGroup
            needTigger={true}
            showGroup={true}
            {...searchGroupProps}
            items={items}
          />
        );
      }
    }
    return group;
  }
}

export default WeaForm;



// WEBPACK FOOTER //
// ./comMobx/wea-form/index.js